import { HttpClient } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { finalize, take } from "rxjs/operators";
import { exportExcel, verifyPhoneNumber } from "src/app/helpers/helpers";
import * as XLSX from "xlsx";

@Component({
  selector: "app-root-send-sms",
  templateUrl: "./root-send-sms.component.html",
  styleUrls: ["./root-send-sms.component.scss"]
})
export class RootSendSmsComponent implements OnInit {
  phonesText = "";
  content = "";
  loading = false;
  output = [];
  iysOutput = [];

  constructor(private http: HttpClient) {}

  ngOnInit(): void {}

  handleFileUpload(event: any) {
    const file = event.target.files[0];
    if (!file) {
      return;
    }

    const reader = new FileReader();
    reader.onload = (e: any) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const firstSheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[firstSheetName];
      const jsonData = XLSX.utils.sheet_to_json(worksheet);

      // Extract phone numbers from the Excel data
      const phones = jsonData
        .map((row: any) => row["Telefon Numarası"]?.toString().trim())
        .filter(Boolean);

      if (phones.length > 0) {
        this.phonesText = phones.join(", ");
      } else {
        alert("Excel dosyasında telefon numarası bulunamadı!");
      }
    };
    reader.readAsArrayBuffer(file);
  }

  sendSms() {
    if (this.loading) {
      return;
    }

    const phones = this.phonesText.split(",").map((phone) => phone.trim());
    if (!phones.length) {
      alert("Lütfen en az bir telefon numarası giriniz!");
      return;
    }

    for (const phone of phones) {
      if (!verifyPhoneNumber(phone, true)) {
        return;
      }
    }

    if (!this.content) {
      alert("Lütfen gönderilecek mesajı giriniz!");
      return;
    }

    this.loading = true;
    this.output = [];
    this.http
      .post("/send-sms", {
        phones,
        content: this.content,
        bulk: true
      })
      .pipe(
        take(1),
        finalize(() => (this.loading = false))
      )
      .subscribe((res: any[]) => {
        this.output = res;
      });
  }

  downloadTemplate() {
    const data = [
      {
        "Telefon Numarası": "5321231212"
      }
    ];
    exportExcel(data, "ornek-sms");
  }

  downloadOutputExcel() {
    const data = this.output.map((item) => ({
      "Telefon Numarası": item.phone,
      Sonuç: item.isSuccess ? "Başarılı" : "Başarısız",
      "Hata Mesajı": item.errorMessage
    }));
    exportExcel(data, "sms-gonderim-sonuclari");
  }

  downloadIysOutputExcel() {
    const data = this.iysOutput.map((item) => ({
      "Telefon Numarası": item.phone,
      Sonuç: item.isSuccess ? "Başarılı" : "Başarısız",
      "Hata Mesajı": item.errorMessage
    }));
    exportExcel(data, "iys-sonuclari");
  }

  clear() {
    this.phonesText = "";
    this.content = "";
    this.output = [];
    this.iysOutput = [];
  }

  sendToIys() {
    if (this.loading) {
      return;
    }

    const phones = this.phonesText.split(",").map((phone) => phone.trim());
    if (!phones.length) {
      alert("Lütfen en az bir telefon numarası giriniz!");
      return;
    }

    for (const phone of phones) {
      if (!verifyPhoneNumber(phone, true)) {
        return;
      }
    }

    this.loading = true;
    this.iysOutput = [];
    this.http
      .post("/send-to-iys", { phones })
      .pipe(
        take(1),
        finalize(() => (this.loading = false))
      )
      .subscribe((res: any[]) => {
        this.iysOutput = res;
      });
  }

  downloadAllSms() {
    this.loading = true;
    this.http
      .get("/manuel-sms-send-logs")
      .pipe(
        take(1),
        finalize(() => (this.loading = false))
      )
      .subscribe((res: any[]) => {
        const data = res.map((item) => ({
          "Telefon Numarası": item.phone,
          "Gönderilen Mesaj": item.content,
          "Gönderim Tarihi": item.createdOn,
          Sonuç: item.isSuccess ? "Başarılı" : "Başarısız",
          "Hata Mesajı": item.errorMessage
        }));
        exportExcel(data, "tum-sms-gonderim-sonuclari");
      });
  }
}
